export const NOTES_FIELD_MIN_ROWS = 4
